import React from 'react';
import { MenuLeafNode } from './menu-nodes/MenuLeafNode';
import { MenuParentNode } from './menu-nodes/MenuParentNode';
import { I18nUtils } from '../../../../../../../i18n/I18nUtils';
import { PsRoutes } from '../../../../../routing/Routes';

export const MyContractorsManagerMenu = () => {
    return (
        <React.Fragment>
            <MenuLeafNode
                icon={'home'}
                label={I18nUtils.tr('TR_INICIO')}
                route={PsRoutes.HOME}
                activeRoutes={[PsRoutes.HOME]}
            />
            <MenuParentNode
                icon={'work'}
                label={I18nUtils.tr('TR_MIS_CONTRATISTAS')}
                activeRoutes={[
                    PsRoutes.MY_CONTRACTORS,
                    PsRoutes.MY_CONTRACTORS_DOCUMENTS,
                    PsRoutes.MY_CONTRACTORS_DOCUMENTS_DETAIL,
                    PsRoutes.MY_CONTRACTORS_WORKERS,
                    PsRoutes.MY_CONTRACTORS_WORKERS_ADD,
                    PsRoutes.MY_CONTRACTORS_WORKERS_DETAIL,
                    PsRoutes.MY_CONTRACTORS_WORKERS_DOCUMENTS_DETAIL,
                    PsRoutes.MY_CONTRACTORS_MACHINES,
                    PsRoutes.MY_CONTRACTORS_MACHINES_ADD,
                    PsRoutes.MY_CONTRACTORS_MACHINES_DETAIL,
                    PsRoutes.MY_CONTRACTORS_MACHINES_DOCUMENTS_DETAIL,
                    PsRoutes.MY_CONTRACTORS_WORKS,
                    PsRoutes.MY_CONTRACTORS_WORKS_DETAIL,
                ]}
            >
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TODOS_LOS_CONTRATISTAS')}
                    route={PsRoutes.MY_CONTRACTORS}
                    activeRoutes={[PsRoutes.MY_CONTRACTORS]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_DOCUMENTOS')}
                    route={PsRoutes.MY_CONTRACTORS_DOCUMENTS}
                    activeRoutes={[
                        PsRoutes.MY_CONTRACTORS_DOCUMENTS,
                        PsRoutes.MY_CONTRACTORS_DOCUMENTS_DETAIL,
                        PsRoutes.MY_CONTRACTORS_WORKERS_DOCUMENTS_DETAIL,
                        PsRoutes.MY_CONTRACTORS_MACHINES_DOCUMENTS_DETAIL,
                    ]}
                />
                <MenuParentNode
                    label={I18nUtils.tr('TR_TRABAJADORES')}
                    activeRoutes={[
                        PsRoutes.MY_CONTRACTORS_WORKERS_ADD,
                        PsRoutes.MY_CONTRACTORS_WORKERS,
                        PsRoutes.MY_CONTRACTORS_WORKERS_DETAIL,
                    ]}
                >
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_NUEVO_TRABAJADOR')}
                        route={PsRoutes.MY_CONTRACTORS_WORKERS_ADD}
                        activeRoutes={[PsRoutes.MY_CONTRACTORS_WORKERS_ADD]}
                    />
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_TODOS_LOS_TRABAJADORES')}
                        route={PsRoutes.MY_CONTRACTORS_WORKERS}
                        activeRoutes={[PsRoutes.MY_CONTRACTORS_WORKERS, PsRoutes.MY_CONTRACTORS_WORKERS_DETAIL]}
                    />
                </MenuParentNode>
                <MenuParentNode
                    label={I18nUtils.tr('TR_MAQUINARIA')}
                    activeRoutes={[
                        PsRoutes.MY_CONTRACTORS_MACHINES_ADD,
                        PsRoutes.MY_CONTRACTORS_MACHINES,
                        PsRoutes.MY_CONTRACTORS_MACHINES_DETAIL,
                    ]}
                >
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_NUEVA_MAQUINARIA')}
                        route={PsRoutes.MY_CONTRACTORS_MACHINES_ADD}
                        activeRoutes={[PsRoutes.MY_CONTRACTORS_MACHINES_ADD]}
                    />
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_TODA_LA_MAQUINARIA')}
                        route={PsRoutes.MY_CONTRACTORS_MACHINES}
                        activeRoutes={[PsRoutes.MY_CONTRACTORS_MACHINES, PsRoutes.MY_CONTRACTORS_MACHINES_DETAIL]}
                    />
                </MenuParentNode>
                <MenuLeafNode
                    label={I18nUtils.tr('TR_OBRAS')}
                    route={PsRoutes.MY_CONTRACTORS_WORKS}
                    activeRoutes={[PsRoutes.MY_CONTRACTORS_WORKS, PsRoutes.MY_CONTRACTORS_WORKS_DETAIL]}
                />
            </MenuParentNode>
        </React.Fragment>
    );
};

MyContractorsManagerMenu.propTypes = {};

MyContractorsManagerMenu.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/menus-by-role/MyContractorsManagerMenu.jsx